import { categoryLabelsEn, articleTypeLabelKeys } from '@/i18n/categoryLabels'

export function localizeCategoryLabel(name, locale = 'zh') {
  const raw = String(name || '').trim()
  if (!raw) return ''
  if (locale !== 'en') return raw
  return categoryLabelsEn[raw] || raw
}

export function articleTypeLabelKey(type) {
  return articleTypeLabelKeys[type] || 'nav.articles'
}
